export default "__VITE_ASSET__zYqjF$WF__"